export default __webpack_public_path__ + "static/media/non-profit-account.b19caceb.png";